/**
 * Utilities for app-version update system.
 */

import vuexStore from '@/store/store';
import { Capacitor } from '@capacitor/core';

const checkIfPwa = () => Capacitor.getPlatform() !== 'web' || Capacitor.isNativePlatform();

const fetchVersionNumber = async () => {
	try {
		// We are storing the version in a json file so that we can check for updates even though the app is not reloaded
		const res = await fetch('/version.json', { cache: 'no-store' });
		const response = await res.json();
		return response ? response.version : null;
	} catch (err) {
		console.error('Failed to fetch version.json', err);
		return null;
	}
};

export const checkIfNewAppVersionExists = async () => {
	const isPwa = checkIfPwa();
	if (isPwa) {
		// no need to check version in PWA
		// PWA has it's own checkVersion system which is the 505 grapql status_code error
		return false;
	} else {
		const oldVersion = await vuexStore.getters['version/getClientVersion'];
		try {
			const version = await fetchVersionNumber();
			// If the system is not able to detect the oldVersion then, there must be some problem so we need to reload.
			// If the version is the same as the old version, then we don't need to reload but we must set the needUpdate status to false to prevent the alert to show.
			if (version) {
				if (oldVersion && version === oldVersion) {
					await vuexStore.dispatch('version/setNewVersionStates', { version, needUpdate: false });
					return false;
				} else {
					await vuexStore.dispatch('version/setNewVersionStates', { version, needUpdate: true });
					return true;
				}
			}
			return false;
		} catch (err) {
			console.error('Failed to fetch version.json', err);
			return false;
		}
	}
};
